// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"663":"fbed2dd4","848":"9f12627c"}[chunkId] + ".chunk.css";
};